import { useRef } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import emailjs from '@emailjs/browser';

function Contact() {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_sxwbbdy', 'template_arj1bcx', form.current, 'rZKepiyo9wEa8G1Tb').then(
      () => {
        alert("Votre message a été envoyé avec succès !");
        form.current.reset();
      },
      (error) => {
        alert("Une erreur est survenue. Veuillez réessayer.", error.text);
      }
    );
  };

  return (
    <div className="dark:bg-fond-sombre">
      <Header/>
      <div className="flex flex-col items-center">
        <div className="relative text-center h-[300px] w-full overflow-hidden">
          <div className="absolute top-[30%] w-full flex flex-col justify-center items-center text-gris-sombre space-y-2">
            <h2 className="px-6 font-comme font-bold text-[40px] md:text-[54px] lg:text-[64px] leading-tight text-center text-gris-sombre dark:text-blanc-sombre">
              Contactez-<span className="text-bleu-je">nous</span> !
            </h2>
            <p className="text-[15px] text-gris-sombre dark:text-blanc-sombre font-normal leading-[18px]">
              Vous avez une question ?
            </p>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-between w-full bg-gris-clair dark:bg-gris-sombre p-5 gap-5">
          <div className="flex-1 flex flex-col gap-5">
            <div className="flex items-center bg-white dark:bg-fond-sombre w-full p-2 box-border">
              <img src="./icons/telephone.svg" alt="phone" className="mr-2" />
              <div>
                <h3 className="text-bleu-je text-[20px] leading-[24px] font-semibold">Numéro de téléphone</h3>
                <p className="mt-1 text-[15px] text-gray-500 dark:text-blanc-sombre">+33 6 73 88 67 87</p>
              </div>
            </div>
            <div className="flex items-center bg-white dark:bg-fond-sombre w-full p-2 box-border">
              <img src="./icons/mail.svg" alt="email" className="mr-2" />
              <div>
                <h3 className="text-bleu-je text-[20px] leading-[24px] font-semibold">Adresse e-mail</h3>
                <p className="mt-1 text-[15px] text-gray-500 dark:text-blanc-sombre">contact@junior-i2c.com</p>
              </div>
            </div>
            <div className="flex items-center bg-white dark:bg-fond-sombre w-full p-2 box-border">
              <img src="./icons/adresse.svg" alt="address" className="mr-2" />
              <div>
                <h3 className="text-bleu-je text-[20px] leading-[24px] font-semibold">Adresse</h3>
                <p className="mt-1 text-[15px] text-gray-500 dark:text-blanc-sombre">109 Avenue Roul, 33400 Talence</p>
              </div>
            </div>
          </div>

          <div className="flex-1 bg-white dark:bg-fond-sombre p-5">
            <h1 className="text-bleu-je text-[32px] leading-[38px] font-semibold mb-5">Envoyez un message</h1>
            <form ref={form} onSubmit={sendEmail} className="flex flex-wrap gap-2">
              <div className="flex-1 min-w-[45%] border border-gray-500 rounded h-[40px] flex items-center overflow-hidden">
                <input type="text" name="nom" placeholder="Nom" className="w-full px-3 py-2 outline-none dark:bg-fond-sombre"/>
              </div>
              <div className="flex-1 min-w-[45%] border border-gray-500 rounded h-[40px] flex items-center overflow-hidden">
                <input type="text" name="prenom" placeholder="Prénom" className="w-full px-3 py-2 outline-none dark:bg-fond-sombre"/>
              </div>
              <div className="flex-1 min-w-[45%] border border-gray-500 rounded h-[40px] flex items-center overflow-hidden">
                <input type="text" name="telephone" placeholder="Numéro de téléphone" className="w-full px-3 py-2 outline-none dark:bg-fond-sombre"/>
              </div>
              <div className="flex-1 min-w-[45%] border border-gray-500 rounded h-[40px] flex items-center overflow-hidden">
                <input type="email" name="email" placeholder="Email" className="w-full px-3 py-2 outline-none dark:bg-fond-sombre"/>
              </div>
              <div className="flex-1 min-w-[45%] border border-gray-500 rounded h-[40px] flex items-center overflow-hidden">
                <input type="text" name="projet" placeholder="Nom du projet" className="w-full px-3 py-2 outline-none dark:bg-fond-sombre"/>
              </div>
              <div className="w-full border border-gray-500 rounded overflow-hidden">
                <textarea name="message" placeholder="Message" className="w-full h-[200px] p-3 outline-none resize-none dark:bg-fond-sombre"></textarea>
              </div>
              <button type="submit" className="relative bg-bleu-je text-white px-5 py-2 ml-auto transition duration-300 ease-in-out hover:bg-white hover:text-bleu-je dark:hover:bg-blanc-sombre border-2 border-bleu-je">
                Envoyer
              </button>
            </form>
          </div>
        </div>

        <div className="bg-white dark:bg-bleu-gris text-center mt-5 p-5 mb-16">
          <h1 className="text-bleu-je dark:text-bleu-sombre text-[36px] leading-[43px] font-semibold">Trouvez-nous sur Google Maps</h1>
          <p className="text-gris-sombre text-[15px] mt-2">À côté de l'arrêt de tram Béthanie</p>
          <a href="https://www.google.com/maps/place/Ing%C3%A9nierie+et+Conseil+en+Cognitique+-+i2c/@44.8062908,-0.5994979,17z/data=!4m6!3m5!1s0xd55277c089d51b9:0x4eabdfee1b57debc!8m2!3d44.806287!4d-0.596923!16s%2Fg%2F11hdc4j52t?entry=ttu&g_ep=EgoyMDI1MDcyOC4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noopener noreferrer">
            <img src="./images/carte.avif" alt="Plan de notre Junior-Entreprise" className="w-full h-auto max-w-[600px] border border-gray-300 rounded mx-auto mt-12 hover:opacity-90 transition"/>
          </a>
        </div>
      </div>
      <Footer/>
    </div>
  );
}

export default Contact;